// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.single-delete {
  width: 30px;
  height: 30px;
  padding: 0.5rem;
  border-radius: 100%;
  border: 1px solid #b1b1b1;
}

.single-input:hover .hide {
  display: inline !important;
}

.hide {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./../job/src/components/PreAssessmentQuestion/PreAssessmentQuestionList/PreAssessmentSingleQn/PreAssessmentSingleQn.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AACF;;AAEA;EAEE,0BAAA;AAAF;;AAGA;EACE,wBAAA;AAAF","sourcesContent":[".single-delete {\n  width: 30px;\n  height: 30px;\n  padding: 0.5rem;\n  border-radius: 100%;\n  border: 1px solid #b1b1b1;\n}\n\n.single-input:hover .hide {\n  // Show the delete button on hover\n  display: inline !important;\n}\n\n.hide {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
